
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaCheckCircle, FaCoins } from "react-icons/fa";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  connectWebSocket,
  listenToEvent,
  disconnectWebSocket,
} from "../payment/webSocketService";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import razorpayicon from "../../assets/razorpay-icon 1.jpg";
// @ts-ignore
import powerPointLogo from "../../assets/PowerPoint logo.jpg";
// @ts-ignore
import googleSlidesLogo from "../../assets/word_icon.png";
import { AnimatePresence, motion } from "framer-motion";
import { getStaticPricing, getCreditPricing } from "../../utils/pricingConfig";
import PaymentGateway, { PaymentGatewayRef } from "../payment/PaymentGateway";
// import Heading from "../extensionLandingPage/LandingPageNavbar";
// import Footer from "./Footer";

interface PricingModalInsufficientCreditsProps {
  // allow both closeModal and onClose naming (export components use onClose)
  closeModal?: () => void;
  onClose?: () => void;
  currency?: string;
  exportButtonText?: string;
  exportButtonBundleText?: string;
  exportHandler?: () => void;
  setIsBundle?: React.Dispatch<React.SetStateAction<boolean>>;
  savings?: string;
  exportType?: "pdf" | "pptx";
  isUnlock?: boolean;
  monthlyPlanAmount?: number;
  yearlyPlanAmount?: number;
  monthlyPlanId?: string;
  yearlyPlanId?: string;
  authToken?: string;
  orgId?: string;
  subscriptionId?: string;
}

interface PaymentData {
  [key: string]: any;
}

interface SubscriptionData {
  [key: string]: any;
}
const testimonials = [
  {
    message:
      "Zynth helped us save hours on presentation content and design. The exports are clean and investor-friendly.",
    name: "Anuj, Co-founder, Skale",
  },
  {
    message: "Used Zynth for my YC deck - clean, fast, and totally worth it.",
    name: "Priya, Founder, CleanCart",
  },
  {
    message:
      "The tool delivers excellent output, creating a well-structured and visually appealing pitch deck.",
    name: "Anthony Crosato",
  },
  {
    message:
      "The pitch deck created through Zynth app is excellent, providing a clear and professional presentation of our ideas.",
    name: "Hitesh Mittal, Founder, Hitech Enviro",
  },
];

export const PricingModalInsufficientCredits: React.FC<PricingModalInsufficientCreditsProps> = ({
  closeModal,
  onClose,
  currency = 'INR',
  exportButtonText = 'Export',
  exportButtonBundleText = 'Bundle',
  exportHandler,
  setIsBundle,
  savings,
  exportType = 'docs',
  isUnlock = false,
  subscriptionId,
  monthlyPlanAmount = 0,
  yearlyPlanAmount = 0,
  yearlyPlanId,
  monthlyPlanId,
  authToken,
  orgId,
}) => {
  const handleClose = closeModal || onClose || (() => {});
  const [isloading, setIsLoading] = useState(false);
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'annual'>('monthly');
  const [creditsAvailable, setCreditsAvailable] = useState(0); // From backend
  const [creditsToBuy, setCreditsToBuy] = useState(10); // For buy credits input
  const [planName, setPlanName] = useState('free');
  const [currencyState, setCurrencyState] = useState<'INR' | 'USD'>(currency === 'INR' ? 'INR' : 'USD');
  const [monthlyPlan, setMonthlyPlan] = useState<any>(null);
  const [yearlyPlan, setYearlyPlan] = useState<any>(null);
  const [isLoadingCredits, setIsLoadingCredits] = useState(false);
  const paymentGatewayRef = useRef<PaymentGatewayRef>(null);
  const userPlan = useSelector((state: any) => state.user.userPlan);
  const userEmail = sessionStorage.getItem("userEmail");
  const displayCurrency = currencyState;
  const pricing = getStaticPricing(displayCurrency);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [fade, setFade] = useState(true);
  // const [visibleKey, setVisibleKey] = useState(Date.now());
  const creditValue = getCreditPricing(currencyState);
  // totalAmount is now calculated inline where needed using creditsToBuy

  // Fetch credits and plan name
  // Fetch credits and plan name
  const fetchCredits = async () => {
    if (!orgId || !authToken) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setCreditsAvailable(typeof res.data?.credits === 'number' ? res.data.credits : 0);
      setPlanName(res.data?.plan?.plan_name || "free");
    } catch (err) {
      console.error("Failed to fetch credits:", err);
      setCreditsAvailable(0);
      setPlanName("free");
    }
  };

  useEffect(() => {
    fetchCredits();
    // Only run on mount or when orgId/authToken changes
  }, [orgId, authToken]);

  // Refresh credits handler
  const refreshCredits = async () => {
    await fetchCredits();
    toast.success("Credits refreshed");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * testimonials.length);
      } while (newIndex === currentIndex);
      setCurrentIndex(newIndex);
  // setVisibleKey(Date.now());
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  // Fetch pricing data for plans and set currency based on location
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const ipRes = await fetch("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
        const ipData = await ipRes.json();
        const country = ipData?.country?.toUpperCase();

        const planRes = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/appscripts/razorpay/plans`,
          { headers: { Authorization: `Bearer ${authToken}` } }
        );

        const plans = planRes.data.items;
        if (country === "IN" || country === "INDIA") {
          setMonthlyPlan(plans[5]);
          setYearlyPlan(plans[3]);
          setCurrencyState("INR");
        } else {
          setMonthlyPlan(plans[4]);
          setYearlyPlan(plans[2]);
          setCurrencyState("USD");
        }
      } catch (err) {
        console.error("Pricing data fetch failed", err);
      }
    };

    fetchPricingData();
  }, [authToken]);

  // const { message, name } = testimonials[currentIndex];
  useEffect(() => {
    if (!orgId) {
      console.error('orgId is required to connect WebSocket')
      return
    }

    connectWebSocket(orgId)

    listenToEvent('payment.authorized', (data: PaymentData) => {
      console.log('Payment authorized:', data)
    })

    listenToEvent('subscription.authenticated', (data: SubscriptionData) => {
      console.log('Subscription authenticated:', data)

      window.location.reload()
    })

    // Cleanup WebSocket on unmount
    return () => {
      disconnectWebSocket()
    }
  }, [orgId])


  const handleUpgrade = async () => {
    if (!monthlyPlan || !yearlyPlan) return;

    setIsLoading(true);
    const planID = billingCycle === "annual" ? yearlyPlan.id : monthlyPlan.id;
    const startAtUnix = Math.floor((Date.now() + 10 * 60 * 1000) / 1000);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/create-subscription`,
        {
          plan_id: planID,
          customer_id: orgId,
          total_count: 12,
          start_at: startAtUnix,
          quantity: 1,
          orgId,
          userId: userEmail,
          notes: { OrgId: orgId },
        },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      const result = response.data;
      if (result.short_url) {
        window.open(result.short_url, "_blank");
      } else {
        alert("Something went wrong with the subscription. Please try again later.");
      }
    } catch (error: any) {
      console.error("Upgrade to Pro failed:", error);
      alert(
        `SORRY!\nWe were unable to process your payment\nError Reason: ${
          (error as any)?.message || error
        }`
      );
    } finally {
      setIsLoading(false);
    }
  };

  // const handleCancel = async () => {
  //   ...existing code...
  // }

  return (
    <>
      <div 
        className={
          !["/presentation-view","/new-presentation","/organization-profile","/history","/edit-organization-profile","/refer"].includes(window.location.pathname) &&
          !window.location.href.includes("/presentation-view?") &&
          !window.location.href.includes("#/history") &&
          !window.location.href.includes("#/refer") &&
          !window.location.href.includes("#/new-presentation") &&
          !window.location.href.includes("#/organization-profile") &&
          !window.location.href.includes("#/edit-organization-profile")
            ? "fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center"
            : "fixed top-0 left-0 w-screen h-screen bg-gray-800 bg-opacity-50 flex justify-center items-center"
        }
        style={{ zIndex: 2147483648 }}
      >
        <div className="bg-white w-[95%] lg:w-[92%] xl:w-[70%] max-h-[95%] md:max-h-[100%] lg:max-h-[98%] overflow-y-auto scrollbar-none rounded-lg shadow-lg p-4 sm:p-6 relative mx-auto">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-900 hover:scale-110 active:scale-95 transform transition text-lg md:text-4xl"
        >
          &times;
        </button>


        <div className="text-center">
          <p className="font-semibold text-2xl sm:text-3xl">
            {isUnlock
              ? "UNLOCK ALL SLIDES AND DOWLOAD YOUR PRESENTATION"
              : `YOUR ${exportType === "docs" ? "WORD" : "POWERPOINT"} DOCUMENT IS `}
            <span className="text-blue-700">{isUnlock ? "" : "READY TO GO"}</span>
          </p>
          {isUnlock ? (
            <p className="text-base mt-2 sm:text-lg">
              Unlock to view the full document. Access all pages, make edits, and export directly to Word or Google Docs.
            </p>
          ) : (
            <p className="text-base mt-2 sm:text-lg">
              Export your {" "}
              <span className="italic font-semibold">
                professionally designed, fully editable document in seconds
              </span>
            </p>
          )}
        </div>


        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-5xl">

          {/* Buy Credits */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-2xl font-bold mb-2">Single Export</h2>
            <p className="text-gray-600 mb-4">Download Word Document.</p>

            {/* Credits Info Section (moved here) */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-2 mb-4">
              <div className="w-full flex flex-col items-center">
                <button
                  onClick={() => {
                    if (exportHandler) exportHandler();
                  }}
                  disabled={planName === 'free' ? creditsAvailable < 20 : false}
                  className={`relative text-white font-semibold py-4 px-4 w-full rounded-lg text-center transition-all ${planName === 'free' && creditsAvailable < 20 ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-700"}`}
                  style={{ background: '#2563eb' }}
                >
                  Export Now
                  {planName === 'free' && (
                    <div className="absolute top-0 right-0 bg-[#091220] text-white text-xs px-2 py-1 rounded-tr-lg rounded-bl-lg flex items-center gap-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" className="text-yellow-400 text-sm" width="16" height="16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 1.5A6.5 6.5 0 1 1 1.5 8 6.508 6.508 0 0 1 8 1.5zm.25 2.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0zm-2.5 2.5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5zm5 0a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5zm-2.5 2.5a.75.75 0 0 0-.75.75v2a.75.75 0 0 0 1.5 0v-2A.75.75 0 0 0 8.25 9.25z"/></svg>
                      20 Credits
                    </div>
                  )}
                </button>
                <span className="block mt-2 text-blue-700 font-semibold text-base flex items-center gap-2 pl-1 text-left w-full">
                  <FaCoins className="text-yellow-500" />
                  Credits Available: {typeof creditsAvailable === 'number' ? creditsAvailable : 0}
                </span>
                <button
                  onClick={refreshCredits}
                  className="text-xs text-blue-500 underline self-start mt-1"
                >
                  ↻ Refresh Credits
                </button>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-2 w-full mb-3">
              <div className="flex items-center gap-2">
                <button
                  className="px-3 py-1 bg-gray-200 rounded"
                  onClick={() => setCreditsToBuy((prev) => Math.max(10, prev - 10))}
                >
                  -
                </button>
                <input
                  type="number"
                  value={creditsToBuy < 10 ? 10 : creditsToBuy}
                  readOnly
                  className="border border-gray-300 rounded px-3 py-2 w-24 text-center"
                  min={10}
                  step={10}
                />
                <button
                  className="px-3 py-1 bg-gray-200 rounded"
                  onClick={() => setCreditsToBuy((prev) => prev + 10)}
                >
                  +
                </button>
              </div>
              <span className="text-lg font-semibold text-black-600">
                {currencyState} {(creditsToBuy * creditValue).toFixed(2)}
              </span>
              <button
                className="bg-blue-600 text-white py-2 px-6 rounded"
                onClick={() => {
                  if (!authToken) {
                    alert("Auth token is missing. Please log in again.");
                    return;
                  }
                  if (paymentGatewayRef.current) {
                    paymentGatewayRef.current.triggerPayment({
                      amount: parseFloat((creditsToBuy * creditValue).toFixed(2)),
                      creditCount: creditsToBuy,
                    });
                  }
                }}
              >
                Buy Credits
              </button>
            </div>
 <p className="text-sm text-gray-500">
              Top up your credits for text refinement, image generation and more.
            </p>

            <div className="mt-6">
              <ul className="space-y-2 text-gray-800">
                {["View & Edit Entire Document", "Refine Text Using AI", "Free AI Image Tools","Compatible with Google Docs"].map((feature) => (
                  <li key={feature} className="flex items-center gap-2">
                    <FaCheckCircle className="text-green-500" /> {feature}
                  </li>
                ))}
              </ul>
            </div>
           
          </div>

          {/* Pro Plan */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-2xl font-bold mb-2">Zynth Pro</h2>
            <p className="text-gray-600 mb-4">Ideal for professionals and businesses.</p>

            <div className="flex flex-col md:flex-row gap-3">
              {["annual", "monthly"].map((cycle) => {
                const plan = cycle === "annual" ? yearlyPlan : monthlyPlan;
                const priceRaw = plan?.item?.amount || 0;
                const totalPrice = priceRaw / 100;
                const monthlyEquivalent = cycle === "annual" ? totalPrice / 12 : totalPrice;

                return (
                  <label
                    key={cycle}
                    className={`flex-1 border rounded-lg p-4 flex justify-between items-start cursor-pointer transition-all gap-2 ${
                      billingCycle === cycle ? "border-blue-600 ring-2 ring-blue-500" : "border-gray-300"
                    }`}
                    onClick={() => setBillingCycle(cycle as 'annual' | 'monthly')}
                  >
                    <div className="flex flex-col gap-1">
                      <div className="text-lg font-semibold">
                        {`${currencyState} ${monthlyEquivalent.toFixed(2)}${cycle === "annual" ? " /month" : ""}`}
                      </div>
                      <div className="text-sm text-gray-500">
                        {cycle === "annual" ? "Billed annually" : "Billed monthly"}
                      </div>
                      {cycle === "annual" && (
                        <span className="mt-1 inline-block w-fit bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded">
                          Save 17%
                        </span>
                      )}
                    </div>

                    <input
                      type="radio"
                      className="form-radio text-blue-600 mt-1 scale-90"
                      checked={billingCycle === cycle}
                      readOnly
                    />
                  </label>
                );
              })}
            </div>

            <button
              className="bg-blue-600 text-white py-2 px-6 rounded mb-4 mt-2"
              onClick={async () => {
                if (!monthlyPlan || !yearlyPlan) return;
                setIsLoading(true);
                const planID = billingCycle === "annual" ? yearlyPlan.id : monthlyPlan.id;
                const startAtUnix = Math.floor((Date.now() + 10 * 60 * 1000) / 1000);
                try {
                  const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/create-subscription`,
                    {
                      plan_id: planID,
                      customer_id: orgId,
                      total_count: 12,
                      start_at: startAtUnix,
                      quantity: 1,
                      orgId,
                      userId: userEmail,
                      notes: { OrgId: orgId },
                    },
                    { headers: { Authorization: `Bearer ${authToken}` } }
                  );
                  const result = response.data;
                  if (result.short_url) {
                    window.open(result.short_url, "_blank");
                  } else {
                    alert("Something went wrong with the subscription. Please try again later.");
                  }
                } catch (error) {
                  console.error("Upgrade to Pro failed:", error);
                  alert(
                    `SORRY!\nWe were unable to process your payment\nError Reason: ${
                      (error as any)?.message || error
                    }`
                  );
                } finally {
                  setIsLoading(false);
                }
              }}
              disabled={isloading}
            >
              {isloading ? "Processing..." : "Upgrade to Pro"}
            </button>

            <p className="text-sm text-gray-500">
              Get unlimited access to all Zynth.ai applications.
            </p>

            <div className="mt-6">
              <ul className="space-y-2 text-gray-800">
                {["Unlimited Presentations & Documents", "Unlimited Export", "Access to All Features", "Priority Rendereing & Support"].map((feature) => (
                  <li key={feature} className="flex items-center gap-2">
                    <FaCheckCircle className="text-green-500" /> {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Hidden PaymentGateway */}
        <PaymentGateway
          ref={paymentGatewayRef}
          authToken={authToken ?? ""}
          productinfo="Credits Purchase"
          isDiscounted={false}
          discountedAmount={0}
          formId={"credits-modal"}
          originalAmount={parseFloat((creditsToBuy * creditValue).toFixed(2))}
          onSuccess={(result: any) => {
            console.log("✅ Payment success", result);
          }}
          onFailure={() => {
            console.warn("❌ Payment failed or cancelled");
          }}
        />

        {/* Testimonial Section */}
        <div className="flex items-center justify-center mt-10">
          <div className="flex flex-col w-full sm:w-[90%] md:w-[70%] lg:w-[70%] xl:w-[60%] h-[30vh] sm:h-[30vh] md:h-[22vh] lg:h-[22vh] xl:h-[22vh] items-center justify-center border border-gray-500 rounded-xl px-4 py-4">
            <p
              className="text-lg italic text-gray-800 mb-2 text-center "
              style={{
                willChange: "opacity, transform, filter",
                backfaceVisibility: "hidden",
                perspective: "1000px",
              }}
            >
              {testimonials[currentIndex].message}
            </p>
            <p
              className="text-sm font-semibold text-blue-700 self-start"
              style={{
                willChange: "opacity, transform, filter",
                backfaceVisibility: "hidden",
                perspective: "1000px",
              }}
            >
              {testimonials[currentIndex].name}
            </p>
            <div className="flex items-center mt-2 justify-start gap-2 w-full">
              {[...Array(5)].map((_, i) => (
                <FontAwesomeIcon
                  key={i}
                  icon={faStar}
                  className="text-yellow-400 w-5 h-5"
                />
              ))}
            </div>
          </div>
        </div>

        {/* Footer Section: Secure payments and compatibility */}
        <hr className="border-t-2 border-dashed border-[#49699987] my-3 w-full" />
        <div className="flex w-full items-center justify-center gap-20 md:flex hidden">
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">Secure payments via</p>
            <img src={razorpayicon} alt="Razorpay" className="h-8 w-auto" />
          </div>
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">Compatible with</p>
            <img src={googleSlidesLogo} alt="Google Slides" className="h-10 w-auto" />
          </div>
        </div>
        <div className="flex flex-col w-full items-center justify-center gap-2 md:hidden">
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">Secure payments via</p>
            <img src={razorpayicon} alt="Razorpay" className="h-8 w-auto" />
          </div>
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">Compatible with</p>
            <img src={googleSlidesLogo} alt="Google Slides" className="h-10 w-auto" />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default PricingModalInsufficientCredits;
